import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExporterColumnTextField`

export default defineMessages({
  textfieldPlaceholder: {
    id: `${scope}.textfieldPlaceholder`,
    defaultMessage: 'Column Name',
  },
})
